export const ItemTypes = {
  IH: "IH",
  IHDKH: "IHDKH",
  MZ: "MZ",
  MN: "MN",
  MR: "MR",
  MARJ: "MARJ",
  MMAB: "MMAB",
  JA: "JA",
  JL: "JL",
  JJ: "JJ",
  JQ: "JQ",
  JZ: "JZ",
  JIBN: "JIBN"
};

export const DAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
export const DURATIONS = ["One", "Two", "Three", "Four", "Five", "Six", "Seven"];

export const FAIZ_ACCESS_TOKEN = "FAIZ_ACCESS_TOKEN";
export const FAIZ_AUTH_EMAIL = "FAIZ_AUTH_EMAIL";
